import { eEndorsements } from '../../enums/eEndorsements';

// @FYI: implementation does not cover all ENUMS
export const endorsementOptions = [
  { label: 'Change Of Partners', value: eEndorsements.ChangeOfPartners },
  { label: 'Contiguity', value: eEndorsements.Contiguity },
  { label: 'NSE', value: eEndorsements.NSE },
  { label: 'Residential', value: eEndorsements.Residential },
  { label: 'Revolving Credit', value: eEndorsements.RevolvingCredit },
  { label: 'Survey', value: eEndorsements.Survey },
  { label: 'Waiver Of Arbitration', value: eEndorsements.WaiverOfArbitration },
  { label: '12-06', value: eEndorsements._12_06 },
  { label: 'Leasehold - Loan', value: eEndorsements._13_1_06 },
  { label: '14-06', value: eEndorsements._14_06 },
  { label: '14-1-06', value: eEndorsements._14_1_06 },
  { label: '14-3-06', value: eEndorsements._14_3_06 },
  { label: '22-06', value: eEndorsements._22_06 },
  { label: '30-06', value: eEndorsements._30_06 },
  { label: '4-06', value: eEndorsements._4_06 },
  { label: '4-1-06', value: eEndorsements._4_1_06 },
  { label: '5-06', value: eEndorsements._5_06 },
  { label: '5-1-06', value: eEndorsements._5_1_06 },
  { label: '6-06', value: eEndorsements._6_06 },
  { label: '6-2-06', value: eEndorsements._6_2_06 },
  { label: '7-06', value: eEndorsements._7_06 },
  { label: '7-1-06', value: eEndorsements._7_1_06 },
  { label: '8-1-06', value: eEndorsements._8_1_06 },
  { label: '9-06', value: eEndorsements._9_06 },
  { label: 'Assignment', value: eEndorsements._10_06 },
  { label: 'T-17', value: eEndorsements._T_17 },
  { label: 'T-19', value: eEndorsements._T_19 },
  { label: 'T-28', value: eEndorsements._T_28 },
  { label: 'T-30', value: eEndorsements._T_30 },
  { label: 'T-31', value: eEndorsements._T_31 },
  { label: 'T-33', value: eEndorsements._T_33 },
  { label: 'T-36', value: eEndorsements._T_36 },
  { label: 'T-42', value: eEndorsements._T_42 },
  { label: 'T-42.1', value: eEndorsements._T_42_1 },
  { label: 'R-24', value: eEndorsements._R_24 },
];
